import * as React from "react";

const SvgSnap = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <mask
      id="snap_svg__a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" fillOpacity={0.92} d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#snap_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.885 6.59q-2.221 0-3.776 1.57-1.555 1.572-1.555 3.816t1.555 3.814q1.554 1.57 3.776 1.57l7.115.057V21l-7.115-.049q-3.687 0-6.286-2.625Q1.999 15.7 2 11.976q0-3.726 2.599-6.35Q7.197 3 10.885 3h7.108v3.59zM20 3h2v3.59h-2zm2 14.416h-2v3.59h2z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgSnap;
